import React from "react";

import { HubButton } from "../../components";

import BarcodePage from "./BarcodePage";
import BarcodeRoll from "./BarcodeRoll";

import { StyledBackgroundStack } from "./styles";

export const BarcodeEditorPreview = ({
  labels = [],
  size = 1,
  pageType = 1,
  isPreview = true,
  ...rest
}) => {
  return (
    <StyledBackgroundStack>
      {pageType ? (
        <BarcodePage labels={labels} key={pageType} size={size} {...rest} />
      ) : (
        <BarcodeRoll labels={labels} key={size} size={size} {...rest} />
      )}
      {isPreview && (
        <HubButton
          variant="contained"
          color="neutral"
          size="small"
          label="This is a Template, to generate Barcodes navigate to the page"
          icon="Eye"
          iconProps={{ size: 12 }}
          sx={{ position: "absolute", bottom: "25px", left: "25px" }}
        />
      )}
    </StyledBackgroundStack>
  );
};

export default BarcodeEditorPreview;
